/* eslint-disable react/prop-types */
export const numberToWords = (number) => {
  if (!number || isNaN(number) || number === 0) return "Không đồng";
  const strNumber = Math.round(number).toString();
  const chuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

  let row = [],
    i = 0;
  for (i = strNumber.length; i > 0; i -= 3) {
    row.push(strNumber.substring(i - 3, i));
  }

  const docHangChuc = (so, daydu) => {
    let chuoi = "";
    let chuc = Math.floor(so / 10);
    let donvi = so % 10;
    if (chuc > 1) {
      chuoi = " " + chuSo[chuc] + " mươi";
      if (donvi === 1) chuoi += " mốt";
    } else if (chuc === 1) {
      chuoi = " mười";
      if (donvi === 1) chuoi += " một";
    } else if (daydu && donvi > 0) {
      chuoi = " linh";
    }
    if (donvi === 5 && chuc >= 1) chuoi += " lăm";
    else if (donvi > 1 || (donvi === 1 && chuc === 0)) chuoi += " " + chuSo[donvi];
    return chuoi;
  };

  const docKhoi = (so, daydu) => {
    let chuoi = "";
    let tram = Math.floor(so / 100);
    so = so % 100;
    if (daydu || tram > 0) {
      chuoi = " " + chuSo[tram] + " trăm";
      chuoi += docHangChuc(so, true);
    } else {
      chuoi = docHangChuc(so, false);
    }
    return chuoi;
  };

  const docSo = (so) => {
    let ketQua = "";
    let viTri = row.length - 1;
    for (let i = viTri; i >= 0; i--) {
      let soNhom = parseInt(row[i]);
      if (soNhom > 0) {
        let cachDoc = docKhoi(soNhom, i !== viTri);
        ketQua += cachDoc + " " + tien[i];
      }
    }
    return ketQua.trim().charAt(0).toUpperCase() + ketQua.trim().slice(1);
  };

  return docSo(number) + " đồng chẵn";
};

const fmt = (n) => (n ? new Intl.NumberFormat("vi-VN").format(n) : "");

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const rowsHtml = rows
    .map(
      (row, i) => `
      <tr>
        <td class="text-center">${row.stt || ""}</td>
        <td>${row.chiTieu || ""}</td>
        <td class="text-center">${row.tyLe || ""}</td>
        <td class="text-right">${fmt(row.nguyenGia)}</td>
        <td class="text-right">${fmt(row.soKhauHao)}</td>
        <td class="text-right">${fmt(row.tk627_4)}</td>
        <td class="text-right">${fmt(row.tk627_5)}</td>
        <td class="text-right">${fmt(row.tk627_6)}</td>
        <td class="text-right">${fmt(row.tk627_7)}</td>
        <td class="text-right">${fmt(row.tk623)}</td>
        <td class="text-right">${fmt(row.tk641)}</td>
        <td class="text-right">${fmt(row.tk642)}</td>
        <td class="text-right">${fmt(row.tk241)}</td>
        <td class="text-right">${fmt(row.tk242)}</td>
        <td class="text-right">${fmt(row.tk335)}</td>
        <td class="text-right">${fmt(row.tkKhac)}</td>
      </tr>
    `
    )
    .join("");

  return `
    <html>
      <head>
        <title>In Bảng Khấu Hao TSCĐ</title>
        <style>
          @media print {
            @page { margin: 10mm; size: landscape; }
          }
          body {
            font-family: "Times New Roman", Times, serif;
            color: #000;
            padding: 20px;
            font-size: 11px;
          }
          .header-top { display: flex; justify-content: space-between; margin-bottom: 20px; }
          .title-box { text-align: center; margin: 20px 0; }
          .title-main { font-size: 16px; font-weight: bold; margin: 0; text-transform: uppercase; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { border: 1px solid #000; padding: 3px; }
          th { text-align: center; font-weight: bold; vertical-align: middle; font-size: 10px; }
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .bold { font-weight: bold; }
          .footer { display: flex; justify-content: space-between; margin-top: 30px; text-align: center; }
        </style>
      </head>
      <body>
        <div class="header-top">
          <div style="width: 50%;">
            <div class="bold">Đơn vị: ${headerInfo.unit}</div>
            <div class="bold">Bộ phận: ${headerInfo.department}</div>
          </div>
          <div style="text-align: center; width: 50%;">
            <div class="bold">Mẫu số 06 - TSCĐ</div>
            <div style="font-style: italic; font-size: 11px;">
              (Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
            </div>
          </div>
        </div>

        <div class="title-box">
          <h2 class="title-main">BẢNG TÍNH VÀ PHÂN BỔ KHẤU HAO TSCĐ</h2>
          <div style="font-style: italic; margin-top: 5px;">
            Tháng ${headerInfo.month} năm ${headerInfo.year}
          </div>
          <div class="text-right" style="margin-top: 10px;">
            Số: ${headerInfo.docNumber}
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th rowspan="2">STT</th>
              <th rowspan="2" style="width: 150px;">Chỉ tiêu</th>
              <th rowspan="2">Tỷ lệ<br/>khấu hao<br/>(%)</th>
              <th colspan="2">Toàn DN</th>
              <th colspan="4">TK 627-Chi phí sản xuất chung</th>
              <th rowspan="2">TK 623</th>
              <th rowspan="2">TK 641</th>
              <th rowspan="2">TK 642</th>
              <th rowspan="2">TK 241</th>
              <th rowspan="2">TK 242</th>
              <th rowspan="2">TK 335</th>
              <th rowspan="2">...</th>
            </tr>
            <tr>
              <th>Nguyên<br/>giá TSCĐ</th>
              <th>Số khấu<br/>hao</th>
              <th>Phân<br/>xưởng 1</th>
              <th>Phân<br/>xưởng 2</th>
              <th>Phân<br/>xưởng 3</th>
              <th>Phân<br/>xưởng 4</th>
            </tr>
            <tr style="background-color: #fafafa;">
              <th>A</th>
              <th>B</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th>5</th>
              <th>6</th>
              <th>7</th>
              <th>8</th>
              <th>9</th>
              <th>10</th>
              <th>11</th>
              <th>12</th>
              <th>13</th>
              <th>...</th>
            </tr>
          </thead>
          <tbody>
            ${rowsHtml}
            <tr style="font-weight: bold; background-color: #eee;">
              <td colspan="2" class="text-center">Cộng</td>
              <td class="text-center">x</td>
              <td class="text-right">${fmt(totals?.nguyenGia)}</td>
              <td class="text-right">${fmt(totals?.soKhauHao)}</td>
              <td class="text-right">${fmt(totals?.tk627_4)}</td>
              <td class="text-right">${fmt(totals?.tk627_5)}</td>
              <td class="text-right">${fmt(totals?.tk627_6)}</td>
              <td class="text-right">${fmt(totals?.tk627_7)}</td>
              <td class="text-right">${fmt(totals?.tk623)}</td>
              <td class="text-right">${fmt(totals?.tk641)}</td>
              <td class="text-right">${fmt(totals?.tk642)}</td>
              <td class="text-right">${fmt(totals?.tk241)}</td>
              <td class="text-right">${fmt(totals?.tk242)}</td>
              <td class="text-right">${fmt(totals?.tk335)}</td>
              <td class="text-right">${fmt(totals?.tkKhac)}</td>
            </tr>
          </tbody>
        </table>

        <div class="footer">
          <div style="width: 50%;">
            <div class="bold">Người lập bảng</div>
            <br/>
            <i style="font-size: 12px;">(Ký, họ tên)</i>
          </div>
          <div style="width: 50%;">
            <div style="font-style: italic; margin-bottom: 5px;">
              Ngày ${headerInfo.day || ""} tháng ${headerInfo.month} năm ${headerInfo.year}
            </div>
            <div class="bold">Kế toán trưởng</div>
            <br/>
            <i style="font-size: 12px;">(Ký, họ tên)</i>
          </div>
        </div>
        <div style="margin-top: 20px; font-size: 12px;">
          <b>Ghi chú:</b> <i style="text-decoration: underline;">Tùy</i> <i style="font-style: italic;">theo đặc điểm hoạt động sản xuất kinh doanh và yêu cầu quản lý của đơn vị mình, doanh nghiệp được xây dựng, thiết kế biểu mẫu chứng từ kế toán.</i>
        </div>
        <script>
          window.onload = function() {
            window.print();
          };
        </script>
      </body>
    </html>
  `;
};
